export default __webpack_public_path__ + "static/media/about-us-contribution.d225cc2b.svg";